import { KnownSDK } from "@contentful/app-sdk";
import { ConditionalFieldMetadata } from "../types";

export const getConditionalFieldMetadata = ({ sdk }: { sdk: KnownSDK }) => {
  return (
    (sdk.parameters.installation
      ?.conditionalFieldMetadata as ConditionalFieldMetadata) || null
  );
};
